import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "@app/services/authentication.service";
import {AuthorizationService} from "@app/services/authorization.service";

@Component({
    selector: 'app-layout-template',
    templateUrl: './layout-template.component.html',
    styleUrls: ['./layout-template.component.css'],
    standalone: false
})
export class LayoutTemplateComponent implements OnInit {

  constructor( private authenticationService: AuthenticationService,
               private authorizationService: AuthorizationService) { }

  ngOnInit(): void {

  }

}
